<p>{{ message }} Do you still want to continue?</p>

<nz-divider class="m-sm" [nzOrientation]="'left'" ></nz-divider>

<sv-container col="2" bordered="false" [size]="'small'">
  <sv label="Created At">{{data.createdAt|date:'MMM dd, yyyy HH:SS'}}</sv>
  <sv label="Created By">{{data.createdBy}}</sv>
  <sv label="Transaction Mode">
    <ng-container [ngSwitch]="data.payMethod">
      <div *ngSwitchCase="1">UOB Transfer</div>
      <div *ngSwitchCase="3">DuitNow</div>
      <div *ngSwitchCase="4">{{useCrossBorderPayment ? 'Cross Border Payment' : 'TT'}}</div>
      <div *ngSwitchCase="5">DuitNow</div>
    </ng-container>
  </sv>
  <ng-container *ngIf="!useCrossBorderPayment">
    <sv label="Pay By A/C">{{data.accountNumber}}</sv>

    <sv label="Pay To">{{data.payeeName}}</sv>
    <sv label="Pay To A/C">{{data.payeeAccount}}</sv>
  </ng-container>

  <sv label="Pay For" type="success">{{data.payForCodes}}</sv>
  <sv label="Ref No.">{{data.payeeRef}}</sv>

  <sv label="Amount">{{ data.amount | currency:data.payeeCurrency }}</sv>

  <sv label="Transaction Date">{{ data.transferDate | customDate }}</sv>
  <sv label="Status">
    <ng-container [ngSwitch]="data.status">
      <nz-tag *ngSwitchCase="0" nzColor="blue">Pending</nz-tag>
      <nz-tag *ngSwitchCase="1" nzColor="success">Success</nz-tag>
    </ng-container>
  </sv>
</sv-container>

